<script lang="ts">
import { defineComponent, Ref, ref } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
import UserService from 'src/core/services/UserService';
import { UserInfo } from 'src/core/types/User';

export default defineComponent({
  name: 'UserInfo',

  components: { NavigationInnerHead },

  setup() {
    const userInfo: Ref<UserInfo> = ref({
      nameSurname: '',
      email: '',
      telephone: '',
      gender: 'E',
      birthday: '',
    });
    const userInfoLoading = ref(false);
    const userUpdateLoading = ref(false);

    userInfoLoading.value = true;
    UserService.userDetail()
      .then(({ status, data }) => {
        if (status._200_) {
          userInfo.value.nameSurname = data.name;
          userInfo.value.email = data.email;
          userInfo.value.telephone = data.telephone;
          userInfo.value.gender = data.gender;
          userInfo.value.birthday = data.birthday;
        }
        userInfoLoading.value = false;
      })
      .catch(() => {
        userInfoLoading.value = false;
      });

    return {
      userInfo,
      userInfoLoading,
      userUpdateLoading,
    };
  },

  methods: {
    updateUser() {
      this.userUpdateLoading = true;
      UserService.updateUser({ ...this.userInfo })
        .then(({ status, message }) => {
          if (status._200_) {
            this.$q.notify({
              color: 'green',
              icon: 'fa-regular fa-circle-check',
              message: 'Üyelik bilgileriniz güncellenmiştir',
            });
          } else {
            this.$q.notify({
              color: 'red',
              icon: 'fa-solid fa-circle-exclamation',
              message,
            });
          }
          this.userUpdateLoading = false;
        })
        .catch(() => {
          this.userUpdateLoading = false;
        });
    },
    openDate() {
      this.$refs.qDateProxy.show();
    },
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex items-center q-mb-md">
      <div>
        <navigation-inner-head title="Kullanıcı Bilgilerim" icon="account_circle" />
      </div>
    </div>
    <q-separator color="accent" />
    <div class="row">
      <div class="col-12 q-py-lg">
        <div>
          <div class="row">
            <div class="col-xs-12 col-md-6 text-center">
              <div class="q-mb-lg">
                <q-input v-model="userInfo.nameSurname" :loading="userInfoLoading" :disable="userInfoLoading" filled label="Ad Soyad" />
              </div>
              <div class="q-mb-lg">
                <q-input v-model="userInfo.email" :loading="userInfoLoading" :disable="userInfoLoading" filled label="E-Posta" />
              </div>
              <div class="q-mb-lg">
                <q-input
                  v-model="userInfo.telephone"
                  :loading="userInfoLoading"
                  :disable="userInfoLoading"
                  filled
                  label="Cep Telefonu"
                  placeholder="(555) 000 00 00"
                  mask="(###) ### ## ##"
                />
              </div>
              <div class="q-my-xl">
                <q-radio val="E" v-model="userInfo.gender" :loading="userInfoLoading" :disable="userInfoLoading" size="sm" label="Erkek" />
                <q-radio val="K" v-model="userInfo.gender" :loading="userInfoLoading" :disable="userInfoLoading" size="sm" label="Kadın" />
                <q-radio val="N" v-model="userInfo.gender" :loading="userInfoLoading" :disable="userInfoLoading" size="sm" label="Belirtmek İstemiyorum" />
              </div>
              <div class="q-mb-lg">
                <q-input
                  filled
                  v-model="userInfo.birthday"
                  :loading="userInfoLoading"
                  :disable="userInfoLoading"
                  label="Doğum tarihiniz"
                  hint="Lütfen doğum tarihinizi belirtiniz"
                  @click="openDate"
                >
                  <template v-slot:append>
                    <q-icon name="event" ref="dateIcon" class="cursor-pointer">
                      <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date v-model="userInfo.birthday" mask="DD/MM/YYYY">
                          <div class="row items-center justify-end">
                            <q-btn v-close-popup label="Kapat" color="red" flat />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="q-mb-sm flex justify-end text-left">
                <q-btn label="Güncelle" color="green" class="q-px-md q-py-xs" size=".85rem" :loading="userUpdateLoading" @click="updateUser" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-card>
</template>

<style scoped></style>
